import React, { useEffect, useState } from 'react';
import { Icon, Label } from 'semantic-ui-react';
import { iconColorTypes } from '../../../enums/settingsIconTypes';
import { NumberPickerDirect } from './NumberPicker';

/**
 * 
 * @param {object} props (checkAllow, allowed, item, itemKey, handleClick, handleCount, handle_click, label, checked, cnp, size, optionalData, asLabel, labelLeft, disabled, useCounter)
 * @returns An Icon/Label combination representing an `Checkbox`
 */
const Checker = (props) => {

  const {
    allowed,
    altLabels,
    asLabel,
    checkAllow,
    checked,
    cnp,
    disabled,
    handle_click,
    handleClick,
    handleCount,
    item,
    itemKey,
    label,
    optionalData,
    prop,
    size,
    useCounter
  } = props

  let allowChecking = true

  if (checkAllow) { allowChecking = allowed ? true : false }

  const [itemChecked, setItemChecked] = useState()

  const useShortLabel = false

  useEffect(() => {
    setItemChecked(checked)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [checked]);

  const handleCheck = (e) => {
    if (disabled && !itemChecked) { return false }
    setItemChecked(!itemChecked)
    item.checked = !itemChecked
    !prop && handleClick && itemKey && handleClick(e, itemKey)
    !prop && handleClick && !itemKey && handleClick(e, item)
    handle_click && !prop && handle_click(e, item, itemChecked, optionalData)
    handleClick && prop && handleClick(prop, item.checked)
    handle_click && prop && handle_click(prop, item.checked)
  }

  const handleCountChange = (v) => handleCount(item, v)

  const counter = () => <NumberPickerDirect onChange={handleCountChange} start={1} end={2} initialValue={1} />

  const checkerText = (_label) => {
    if (altLabels && altLabels.length > 0) {
      const lbls = altLabels.map(lbl => <label>{lbl}</label>)
      return <div className={'checker-text'}>
        {_label && <label>{_label}</label>}
        {altLabels && lbls}
      </div>
    } else {
      return <div><label>{_label}</label></div>
    }
  }

  const checker = () => {
    const checkColor = handle_click ? iconColorTypes.success : iconColorTypes.menuItem
    let icon = itemChecked ? 'check' : 'square outline'
    const color = itemChecked ? checkColor : iconColorTypes.default
    if (disabled && !itemChecked) { icon = 'minus' }
    let cn = 'checker'
    if (cnp) { cn += ' ' + cnp }
    if (useCounter) { cn += ' counter' }
    if (altLabels) { cn += ' alt' }

    const _label = useShortLabel && label && label.length > 40 ? label.substring(0, 40) + '...' : label

    if (asLabel) {
      return <div className={cn}>
        <Label key={item.key} propname={item.key} bordered color={color} size={size} inverted onClick={(e) => { !disabled && handleCheck(e) }}>{_label}</Label>
        {useCounter && itemChecked && counter()}
      </div>
    } else {
      return <div className={cn}>
        {allowChecking && <div><Icon key={item.key} propname={item.key} bordered color={color} size={size} inverted name={icon} onClick={(e) => { !disabled && handleCheck(e) }} /></div>}
        {checkerText(_label)}
        {useCounter && itemChecked && counter()}
      </div>
    }
  }
  return checker()
}

export default Checker